import { TABLET, DESKTOP, WIDE, ULTRA } from '../breakpoint/name';

const DEFAULT_BREAKPOINTS = [TABLET, DESKTOP, WIDE, ULTRA];

export {
  DEFAULT_BREAKPOINTS,
};
